export default "__VITE_ASSET__33368f63__"